var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-pay-BR", style: `paddingTop:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: _vm.$t("lang.pay.store"), "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c("div", { staticClass: "coin arTitRight15 arRightRound" }, [
                  _c("img", {
                    staticClass: "arLeftM5",
                    attrs: { src: _vm.getMatchImg("coin"), alt: "" },
                  }),
                  _c("i", [_vm._v(_vm._s(_vm.userInfo.coinsNum))]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      !_vm.loadingFlag
        ? _c(
            "div",
            { staticClass: "main" },
            [
              _vm.promotionalGoods
                ? _c(
                    "div",
                    {
                      staticClass: "discount-box",
                      class: {
                        loseSelect: _vm.selectGid != _vm.promotionalGoods.gid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSelete(_vm.promotionalGoods)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "add-money",
                          class: {
                            addRight: _vm.promotionalGoods.discountType == 2,
                          },
                        },
                        [
                          _c("div", { staticClass: "add" }, [
                            _c("div", { staticClass: "add-box" }, [
                              _c("div", { staticClass: "add-discount" }, [
                                _vm._v(_vm._s(_vm.promotionalGoods.discount)),
                              ]),
                              _c("img", {
                                staticClass: "add-box-bg",
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Boys/PayStore/vava/arrow_yellow.png"),
                                  alt: "",
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "money" }, [
                            _c("img", {
                              staticClass: "icon-money",
                              attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.promotionalGoods.amount)),
                            ]),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "method" }, [
                        _c("div", { staticClass: "method-icon" }, [
                          _c("img", {
                            staticClass: "icon-discount",
                            attrs: {
                              src: _vm._f("imgPath")(_vm.promotionalGoods.icon),
                              alt: "",
                            },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.promotionalGoods.goodDesc) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            _vm._s(_vm.promotionalGoods.currency) +
                              _vm._s(_vm.promotionalGoods.brlPrice / 100)
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("lang.payPT.selectAmount"))),
              ]),
              _c(
                "div",
                { staticClass: "recharge" },
                _vm._l(_vm.rechargeList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.gid,
                      staticClass: "option",
                      class: { selectAct: _vm.selectGid == item.gid },
                      on: {
                        click: function ($event) {
                          return _vm.handleSelete(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "option-top" }, [
                        item.label
                          ? _c("img", {
                              staticClass: "best-img",
                              attrs: {
                                src: _vm._f("imgPath")(item.label),
                                alt: "",
                              },
                            })
                          : _vm._e(),
                        _c("img", {
                          staticClass: "money-img",
                          attrs: { src: _vm.getMatchImg("coin"), alt: "" },
                        }),
                        _c("span", [_vm._v(_vm._s(item.amount))]),
                      ]),
                      item.goodDesc
                        ? _c(
                            "div",
                            { staticClass: "discount-num" },
                            [
                              _vm._l(
                                _vm.handleTipsFormat(item.goodDesc),
                                function (desc) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: desc,
                                        staticClass: "discount-num-tips",
                                      },
                                      [
                                        desc.indexOf("videopass") !== -1
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  "+" +
                                                    _vm._s(
                                                      desc.replace(
                                                        "videopass",
                                                        ""
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.getMatchImg(
                                                    "video-pass"
                                                  ),
                                                  width: "13",
                                                  height: "12",
                                                },
                                              }),
                                            ]
                                          : desc.indexOf("coin") !== -1
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  "+" +
                                                    _vm._s(
                                                      desc.replace("coin", "")
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.getMatchImg("coin"),
                                                  width: "13",
                                                  height: "12",
                                                },
                                              }),
                                            ]
                                          : [
                                              _c("span", [
                                                _vm._v("+" + _vm._s(desc)),
                                              ]),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("lang.wd.methodTit"))),
              ]),
              _c("CouponEnter", {
                attrs: { maxCoupon: _vm.maxCoupon, styleType: "for-vava" },
                on: { openCouponPop: _vm.openCouponPop },
              }),
              _vm._l(_vm.payMothods, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    class: [
                      "method-item",
                      _vm.loadingShow ? "activeLoading" : "",
                      _vm.disClassFn(item.desc, _vm.packageName),
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.selectPayMothod(item, index)
                      },
                    },
                  },
                  [
                    item.desc
                      ? _c("MyPLabel", {
                          staticClass: "discount",
                          attrs: {
                            str: item.desc,
                            customClass: { coin: "discount-coins" },
                          },
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "method-con" }, [
                      _c(
                        "div",
                        {
                          staticClass: "img-name",
                          class: { noClick: _vm.loadingShow },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.icon),
                              alt: "",
                            },
                          }),
                          _c("i", { staticClass: "line" }),
                          _c("span", [_vm._v(_vm._s(item.name))]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "money-num",
                          class: { noClick: _vm.loadingShow },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "money-discount-price" },
                            [
                              _c(
                                "i",
                                {
                                  class: {
                                    actTextColor:
                                      _vm.loadingShow &&
                                      item.name == _vm.selectPayName,
                                  },
                                },
                                [_vm._v(_vm._s(item.currency))]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    actTextColor:
                                      _vm.loadingShow &&
                                      item.name == _vm.selectPayName,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.handleDiv100(item.price)))]
                              ),
                              _vm.loadingShow && item.name == _vm.selectPayName
                                ? _c("van-loading", {
                                    staticClass: "pay-loading",
                                    attrs: {
                                      type: "spinner",
                                      color: "#FFFFFF",
                                      size: "20px",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              }),
              _vm.googleData[0]
                ? _c("GooglePay", {
                    class: { noClick: _vm.loadingShow },
                    attrs: {
                      loadingShow: _vm.loadingShow,
                      googlePrice: _vm.googleData[0].price,
                      currency: _vm.googleData[0].currencyCode,
                      styleType: "for-vava",
                    },
                    on: { googlePay: _vm.googlePay },
                  })
                : _vm._e(),
            ],
            2
          )
        : _c("content-loader", { attrs: { width: 400, height: 900 } }),
      _c("PayResult", {
        attrs: {
          showDiaC: _vm.showResultDia,
          oneShow: true,
          title: _vm.payResultText,
        },
      }),
      _vm.validCouponListSort
        ? _c("CouponPopup", {
            attrs: {
              active: _vm.popActive,
              showCouponPopup: _vm.showCoupon,
              tebTit: _vm.tebTit,
              maxCoupon: _vm.maxCoupon,
              styleType: `for-${_vm.packageName}`,
              validCouponListSort: _vm.validCouponListSort,
              expiredCouponList: _vm.expiredCouponList,
            },
            on: {
              close: _vm.closePop,
              confirmChooseCouponId: _vm.confirmChooseCouponId,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }